import React from 'react';
import { Clock } from 'lucide-react';

const SEEN_TEAL = '#008C8C';

const CheckIcon = ({ size = 14, color = '#ffffff', style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const DoubleCheckIcon = ({ size = 18, color = '#ffffff', style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <polyline points="18 6 7 17 2 12" />
    <polyline points="22 6 11 17 8.5 14.5" />
  </svg>
);

const DeliveryIndicator = ({ status, time, isGroup, readCount }) => {
  const getIndicator = () => {
    switch (status) {
      case 'sending':
        return (
          <Clock
            size={13}
            style={{
              color: '#9ca3af',
              transition: 'color 0.3s ease',
              flexShrink: 0,
            }}
          />
        );
      case 'sent':
        return (
          <CheckIcon
            size={14}
            color="currentColor"
            style={{ transition: 'color 0.3s ease', flexShrink: 0, opacity: 0.8 }}
          />
        );
      case 'delivered':
        return (
          <DoubleCheckIcon
            size={17}
            color="currentColor"
            style={{ transition: 'color 0.3s ease', flexShrink: 0, opacity: 0.8 }}
          />
        );
      case 'read':
      case 'seen':
        return (
          <DoubleCheckIcon
            size={17}
            color={SEEN_TEAL}
            style={{ transition: 'color 0.3s ease', flexShrink: 0 }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        marginLeft: '6px',
        flexShrink: 0,
        verticalAlign: 'middle',
      }}
    >
      {time && (
        <span
          style={{
            fontSize: '11px',
            color: 'rgba(255,255,255,0.65)',
            fontWeight: '400',
            lineHeight: 1,
            whiteSpace: 'nowrap',
          }}
        >
          {time}
        </span>
      )}
      {getIndicator()}
      {isGroup && readCount > 0 && (
        <span
          style={{
            fontSize: '11px',
            color: status === 'read' || status === 'seen' ? SEEN_TEAL : 'rgba(255,255,255,0.8)',
            fontWeight: '600',
            marginLeft: '2px',
          }}
          title={`Seen by ${readCount}`}
        >
          {readCount}
        </span>
      )}
    </span>
  );
};

export default DeliveryIndicator;
